import autenticacao from './autenticacaoRepository'
import configuracao from './configuracaoRepository'
import gestor from './gestorRepository'
import notificacao from './notificacaoRepository'
import papel from './papelRepository'
import permissao from './permissaoRepository'
import relatorioAcessoFuncionalidade from './relatorioAcessoFuncionalidadeRepository'
import relatorioAcessoSistema from './relatorioAcessoSistemaRepository'
import relatorioHistoricoPapelLotacao from './relatorioHistoricoPapelLotacaoRepository'
import relatorioHistoricoPermissaoLotacao from './relatorioHistoricoPermissaoLotacaoRepository'
import relatorioHistoricoPermissaoPapel from './relatorioHistoricoPermissaoPapelRepository'
import relatorioPapelLotacao from './relatorioPapelLotacaoRepository'
import relatorioPermissaoLotacao from './relatorioPermissaoLotacaoRepository'
import relatorioPermissaoPapel from './relatorioPermissaoPapelRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/administracao`

    return {
        autenticacao: autenticacao(baseUrl),
        configuracao: configuracao(baseUrl),
        gestor: gestor(baseUrl),
        notificacao: notificacao(baseUrl),
        papel: papel(baseUrl),
        permissao: permissao(baseUrl),
        relatorioAcessoFuncionalidade: relatorioAcessoFuncionalidade(baseUrl),
        relatorioAcessoSistema: relatorioAcessoSistema(baseUrl),
        relatorioHistoricoPapelLotacao: relatorioHistoricoPapelLotacao(baseUrl),
        relatorioHistoricoPermissaoLotacao: relatorioHistoricoPermissaoLotacao(baseUrl),
        relatorioHistoricoPermissaoPapel: relatorioHistoricoPermissaoPapel(baseUrl),
        relatorioPapelLotacao: relatorioPapelLotacao(baseUrl),
        relatorioPermissaoLotacao: relatorioPermissaoLotacao(baseUrl),
        relatorioPermissaoPapel: relatorioPermissaoPapel(baseUrl),
    }
}
